import AppModal from "@/components/AppModal";
import {Box, Stack} from '@mui/material'
import RpIcon from "@/components/RpIcon";
import SkeletonTransDetail from "@/components/skeleton/TransDetail";
import API from "@/constant/API";
import {ORDER_STATUS} from "@/constant/Constant";
import axiosInstance from "@/utils/axios";
import {toListItemDateString} from "@/utils/dateUtils";
import {getIconByBizType, getResourceByMcc, getResourceByMccName} from "@/utils/utils";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {enqueueSnackbar} from "notistack";

interface Props {
  open: boolean;
  onClose: () => void;
  sn: string
}

export interface AssetTransItemType {
  businessSn: string;
  businessType: number;
  amount: string;
  address: string;
  varietyCode: string;
  createTime: number;
  coin: string;
  merchantName: string;
  mcc: string;
  cardId: string;
  cardLast4: string;
  transactionId: string;
  status: number;
  businessTypeDisplayName: string;
  businessModuleDisplayName: string;
  name: string,
  isRefund: number
}

export default function AssetsTransDetail({open, onClose, sn}: Props) {
  const {t} = useTranslation("translation");
  const [loading, setLoading] = useState(true);
  const [item, setItem] = useState({})

  useEffect(() => {
    getData();

  }, []);

  const getData = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.post(API.ASSETS_TRANS_DETAIL, {sn});
      setItem(res);

    } catch (e) {
      console.error(e);
      enqueueSnackbar(e.message, {variant: "error"})

    } finally {
      setLoading(false)
    }


  }

  // const handleCancelOrder = async () => {
  //   await axiosInstance.post(API.WITHDRAW_CANCEL, {
  //     sn: item.sn,
  //   });
  // };

  const _renderIcon = (isCardTrans: boolean) => {
    if (isCardTrans) {
      let icon = getResourceByMccName(item.merchantName);
      let merchantIcon = !!icon;
      if (!icon) icon = getResourceByMcc(item.mcc);
      if (icon) {
        if (merchantIcon) {
          return <img src={icon}/>
        } else {
          return <Box>
            <img src={icon}/>
          </Box>
        }
      } else {
        icon = 'card-info';
      }
      return <Box>
        <RpIcon icon={icon} size={18}/>
      </Box>
    } else {
      const icon = getIconByBizType(item.businessType);
      return <Box>
        {icon ? <RpIcon icon={icon} size={24}/> : <RpIcon icon={"card-consume"} size={24}/>}
      </Box>
    }
  }

  return (
    <AppModal open={open} onClose={onClose} width={490}>
      {loading ? <Box sx={{padding: '24px'}}>
        <SkeletonTransDetail/>
      </Box> : <Box sx={{padding: '24px'}}>
        <Stack direction="column" spacing={2}>
          <Box>
            {_renderIcon(!!item.cardId)}
            <Stack direction="row" justifyContent="space-between">
              <Box>
                {item.businessTypeDisplayName}
              </Box>
              <Box>{`${item.amount} ${item.varietyCode?.toUpperCase()}`}</Box>
            </Stack>
          </Box>
          <Stack direction="row" justifyContent="space-between">
            <Box>{t("business_sn")}</Box>
            <Box>{item.businessSn}</Box>
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            <Box>{t("type")}</Box>
            <Box>{item.businessTypeDisplayName}</Box>
          </Stack>

          <Stack direction="row" justifyContent="space-between">
            <Box>{t("amount")}</Box>
            <Box>
              {item.amount} {item.varietyCode?.toUpperCase()}
            </Box>
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            <Box>{t("create_time")}</Box>
            <Box>
              {toListItemDateString(new Date(item.createTime))}
            </Box>
          </Stack>
          {item.address && (
            <Stack direction="row" justifyContent="space-between">
              <Box>{t("address")}</Box>
              <Box>{item.address}</Box>
            </Stack>
          )}

          {item.cardId && (
            <Stack direction="row" justifyContent="space-between">
              <Box>{t("card_id")}</Box>
              <Box>
                {`\u2022\u2022\u2022\u2022 ${item.cardLast4}`}
              </Box>
            </Stack>
          )}
          {item.cardId && (
            <Stack direction="row" justifyContent="space-between">
              <Box>{t("card_trans_id")}</Box>
              <Box>{item.transactionId}</Box>
            </Stack>
          )}
          {item.status === ORDER_STATUS.CANCELED && (
            <Stack direction="row" justifyContent="space-between">
              <Box>{t("status")}</Box>
              <Box>{t("refunded_success")}</Box>
            </Stack>
          )}
        </Stack>
      </Box>}
    </AppModal>
  );
}
